import { Shield, Lock, HardDrive, FileCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ScrollReveal } from './ScrollReveal';

const privacyIcons = [HardDrive, Lock, FileCheck, Shield];

export function Privacy() {
  const { t } = useTranslation();

  const privacyFeatures = [
    {
      icon: privacyIcons[0],
      titleKey: 'privacy.local.title',
      descriptionKey: 'privacy.local.description',
    },
    {
      icon: privacyIcons[1],
      titleKey: 'privacy.anonymization.title',
      descriptionKey: 'privacy.anonymization.description',
    },
    {
      icon: privacyIcons[2],
      titleKey: 'privacy.fullPrivacy.title',
      descriptionKey: 'privacy.fullPrivacy.description',
    },
    {
      icon: privacyIcons[3],
      titleKey: 'privacy.encryption.title',
      descriptionKey: 'privacy.encryption.description',
    },
  ];

  return (
    <section id="privacy" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-6">
              <Shield className="size-5" />
              <span className="font-semibold">{t('privacy.badge')}</span>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              {t('privacy.title')}
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={2}>
            <p className="text-lg text-gray-600">
              {t('privacy.subtitle')}
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {privacyFeatures.map((feature, index) => (
            <ScrollReveal key={index} delay={(index % 6) + 1}>
              <div className="bg-white rounded-xl p-8 border-2 border-teal-200">
                <div className="bg-teal-100 rounded-lg p-3 inline-block mb-4">
                  <feature.icon className="size-8 text-teal-600" />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(feature.descriptionKey)}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
